import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import {
  AP_API_CHECK_ROUTE_ACCESS,
  AB_API_REFRESH_SESSION
} from '../constants';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {
  count = 0;
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf('sitecore') === -1 &&
      req.url.indexOf(AP_API_CHECK_ROUTE_ACCESS) === -1 &&
      req.url.indexOf(AB_API_REFRESH_SESSION) === -1 &&
      !req.headers.has('withoutLoader')
    ) {
      this.count++;
      this.loaderService.show();

      return next.handle(req).pipe(
        finalize(() => {
          this.count--;
          if (this.count === 0) {
            setTimeout(() => {
              if (this.count === 0) {
                this.loaderService.hide();
              }
            }, 500);
          }
        })
      );
    } else {
      if (req.headers.has('withoutLoader')) {
        const newHeaders = req.headers.delete('withoutLoader');
        req = req.clone({ headers: newHeaders });
      }

      return next.handle(req);
    }
  }
}
